import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {IdentifierInputModule} from '../../common/identifier-input/identifier-input.module';
import {InputRestrictionsModule} from '../../../directives/input-restrictions.module';
import {InvitationService} from '../../../service/invitation.service';
import {HTTP_INTERCEPTORS} from '@angular/common/http';
import {OtpComponent} from './otp.component';
import {AuthTokenInterceptor} from '../../../http/interceptors/auth-token.interceptor';
import {HttpErrorInterceptor} from '../../../http/interceptors/http-error.interceptor';

@NgModule({
    imports: [CommonModule, FormsModule, IdentifierInputModule, InputRestrictionsModule],
    declarations: [OtpComponent],
    exports: [OtpComponent],
    providers: [InvitationService, {
        provide: HTTP_INTERCEPTORS,
        useClass: AuthTokenInterceptor,
        multi: true
    }, {
        provide: HTTP_INTERCEPTORS,
        useClass: HttpErrorInterceptor,
        multi: true
    }]
})

export class OtpModule {
}
